import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SectoresOrganizacionalesService {

  urlSectoresOrganizacionales: string = `${environment.apiSectoresOrg.context}`;
  
  
  urlOcupaciones: string = `${environment.apiSectoresOrg.context}${environment.apiSectoresOrg.methods.ocupaciones}`;
  urlNiveles: string = `${environment.apiSectoresOrg.context}${environment.apiSectoresOrg.methods.nieveles}`;
  urlNivelXSector: string = `${environment.apiSectoresOrg.context}${environment.apiSectoresOrg.methods.getNivelXSector}`;
  urlEstandares: string = `${environment.apiSectoresOrg.context}${environment.apiSectoresOrg.methods.estandares}`;
  urlGetDadAndId: string = `${environment.apiSectoresOrg.context}${environment.apiSectoresOrg.methods.getDadAndId}`;
  requestOptions: any;

  constructor(private http: HttpClient) { 
    this.requestOptions = { headers: new HttpHeaders({ 'content-type': "application/json; charset=utf-8" }) };
  }

  getSectoresOrganizacionales(): Promise<any> {
    return this.http.get<any>(this.urlSectoresOrganizacionales).toPromise();
  }

  getOcupaconesBySector(idSector: number): Promise<any> {
    return this.http.get<any>(`${this.urlOcupaciones}/${idSector}`).toPromise();
  }

  getNivelesById(idOcupacon: number): Promise<any> {
    return this.http.get<any>(`${this.urlNiveles}/${idOcupacon}`).toPromise();
  }

  getNivelesXSectorById(idOcupacon: number): Promise<any> {
    return this.http.get<any>(`${this.urlNivelXSector}/${idOcupacon}`).toPromise();
  }

  getEstandaresById(idNivel: number): Promise<any> {
    return this.http.get<any>(`${this.urlEstandares}/${idNivel}`).toPromise();
  }

  getDadAndId(id: number, name: string): Promise<any> {
    return this.http.get<any>(`${this.urlGetDadAndId}/${name}/${id}`).toPromise();
  }
}
